import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
} from '@angular/core';
import {
  AppState,
  FilterState,
  PriceFilterState,
  PriceRange,
  RangeSliderOption,
} from '@immosky/types';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
  isPriceFilterActive,
  selectFilterState,
} from '@immosky/object-search-filter';

@Component({
  selector: 'lib-price-filter',
  templateUrl: './price-filter.component.html',
  styleUrls: ['./price-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceFilterComponent implements OnDestroy {
  private subscriptions: Subscription[] = [];

  options: RangeSliderOption[] = [];
  currentFilter!: PriceRange;
  priceFilterState!: PriceFilterState;

  @Output()
  update = new EventEmitter<PriceRange>();

  get canReset(): boolean {
    return isPriceFilterActive(
      this.currentFilter,
      this.priceFilterState.default
    );
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    const subscription = this.store
      .pipe(select(selectFilterState))
      .subscribe((filterState: FilterState) => {
        this.priceFilterState = filterState.price;

        this.currentFilter = {
          ...filterState.price.filter,
        };

        this.options = this.priceFilterState.options;
        this.cdRef.markForCheck();
      });

    this.subscriptions.push(subscription);
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  reset() {
    this.currentFilter.min = this.options[0];
    this.currentFilter.max = this.options[this.options.length - 1];
    this.emitChange();
  }

  selectMin(option: RangeSliderOption) {
    this.currentFilter.min = option;
    this.emitChange();
  }

  selectMax(option: RangeSliderOption) {
    this.currentFilter.max = option;
    this.emitChange();
  }

  private emitChange() {
    this.update.emit(this.currentFilter);
  }
}
